import React from 'react';
import PressableScale from './motion/PressableScale';

// Filter chip: brightens on hover (when not active), dips on press, springs
// back. One feel for every chip on the results page (Oct 2026 motion pass).
const HOVER = { backgroundColor: 'rgba(255,255,255,0.1)', borderColor: 'rgba(255,255,255,0.32)' };

const HoverTag = ({ onPress, style, isActive, children, hoverStyle, ...rest }) => (
    <PressableScale
        onPress={onPress}
        style={style}
        hoverStyle={isActive ? null : (hoverStyle === undefined ? HOVER : hoverStyle)}
        scaleTo={0.96}
        accessibilityRole="button"
        accessibilityState={{ selected: !!isActive }}
        {...rest}
    >
        {children}
    </PressableScale>
);

export default HoverTag;
